<template>
    <div>
        <div>
            Пароль:
        </div>
        <div>
            <input class="form-control" v-model="token">
        </div>
        <div>
            <button class="btn btn-success" @click="save()">Сохранить</button>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';


    export default {
        name: "Token",
        methods: {
            ...mapActions('app', {
                setToken: 'setToken',
            }),
            save() {
                this.setToken(this.token);
                this.$router.push('/');
            },
        },
        data() {
            return {
                token: '',
            };
        },
    }
</script>

<style scoped>
    .btn {
        width: 100%;
    }
</style>
